import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteConfirmModal = ({ open, supplyName, onClose, onDelete }) => {
  
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('confirm_deletion')}</DialogTitle>
      <DialogContent>
        <Typography>{t('delete_supply_confirmation', {supplyName})}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={onDelete} variant="contained" color="error">{t('delete_supply')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmModal;
